import VerifyEmail from 'modules/auth/components/VerifyEmail/VerifyEmail';

export default VerifyEmail;
